import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { PageHero } from "@/components/shared/PageHero";
import { Home, ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="relative min-h-[calc(100vh-4rem)]">
      <div
        aria-hidden
        className="absolute inset-0 -z-10 opacity-60 pointer-events-none"
        style={{
          background:
            "radial-gradient(50% 50% at 50% 30%, hsl(var(--primary) / 0.15), transparent 70%)",
        }}
      />
      <div className="relative max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <PageHero
          eyebrow="Page not found"
          title="404"
          accent="Lost in space"
          subtitle="The page you're looking for doesn't exist or has moved. Let's get you back on track."
          centered
          ctas={[
            { label: "Back to Home", to: "/", icon: <Home className="w-4 h-4" /> },
            {
              label: "Go Back",
              onClick: () => navigate(-1),
              variant: "secondary",
              icon: <ArrowLeft className="w-4 h-4" />,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default NotFound;
